/* istanbul ignore file */
import React from 'react';
import { useShowContext } from 'framework/show';
import { EnumField } from 'framework/ui/field';
import { LEAD_POSTPONED_REASON } from 'domain/sales/lead/shared/leadService';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';

interface PostponedReasonFieldProps {
  inputValue?: string;
  source: string;
  isVisible?: boolean | ((data: FormFieldsData) => boolean);
}

const PostponedReasonField: React.FC<PostponedReasonFieldProps> = ({ inputValue, source }) => {
  const { data } = useShowContext();
  const value = inputValue || (data && data.getValueBySource(source));

  return <EnumField label="Postponed Reason" options={LEAD_POSTPONED_REASON} value={value} />;
};

export default PostponedReasonField;
